import makeStyles from '@mui/styles/makeStyles'

export default makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.elements.white,
    color: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.elements.white
    }
  },

  selected: {
    backgroundColor: theme.palette.primary.light
  },

  dayOff: {
    color: theme.palette.text.light,
    '&:hover': {
      backgroundColor: theme.palette.dark.main,
      color: theme.palette.elements.white
    }
  },

  dayOffSelected: {
    backgroundColor: theme.palette.elements.main,
    color: theme.palette.text.primary
  }
}))
